import {DG_axios} from "../../../../custom/axios";

const baseURL = `/dogoo/job-position-rest/v2.0/job-positions`

export async function getJobPositions(filter, page, pageSize, search, sort ) {
    const response = await DG_axios.get(baseURL ,
        {
            params: {
                filter,
                page,
                pageSize,
                search,
                sort
            }
        })
    return response?.data || []
}

export async function getJobPositionById(id) {
    const response = await DG_axios.get(baseURL + `/${id}`)
    return response?.data || []
}



